import {createStore} from 'vuex'
import {storeUpdate} from 'Common/Logical/Helpers/StoreHelpers.js'

export const SET_AUTH = 'G_SET_AUTH'

// Function to create the global store
function makeStore() {
    return createStore({
        state: {
            auth: window.PHPVars && window.PHPVars.auth ? window.PHPVars.auth : {__isEmpty: true},
        },
        strict: process.env.NODE_ENV !== 'production',
        mutations: {
            [SET_AUTH](state, payload) {
                storeUpdate(state.auth, payload)
            },
        },
    })
}

// Create a instance of a global store
const __globalStore = makeStore()

// If we are in a testing environment create a new store for each make request.
// In production or development always use the same store.
export function makeGlobalStore() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV === 'testing') {
        return makeStore()
    } else {
        return __globalStore
    }
}

// Function for accessing the store state
export function getGlobalState() {
    return JSVars.VueBus.store._state.data;
}

export function commitToGlobal(action, payload) {
    JSVars.VueBus.store.commit(action, payload)
}
